module.exports = __webpack_public_path__ + "media/src/assets/Images/RoomPNG-65887830e1815077858d8d276ad58466.png";